import type { SyntheticEvent } from "react";

export const onImageLoadError = (e: SyntheticEvent<HTMLImageElement>) => {
  (e.target as HTMLImageElement).style.opacity = "0";
  // @ts-ignore
  (e.target as HTMLImageElement).parentElement.style.backgroundColor = "#444";
};
